import { TreeBuilder } from "../tree-builder";
import { ColorTreeNode } from "./color-tree-node";
import { TreeNode } from "../lib/tree-node";
import { TreeRepBuilder } from "../tree-rep-builder";

/**
 * A tree with colored nodes. Color can occur multiple times
 *  deprecated
 */
export abstract class ColorTreeRepBuilder extends TreeRepBuilder {
    constructor(depth: number, set: any[], canvas: HTMLCanvasElement) {
        super(depth, set, canvas);
    }

    abstract leftClickTreeNode(treeNode: TreeNode);

    protected createNewNode(row:number, col:number, id:number, 
        parent:TreeNode, content: any[], alphabet: any[], depth: number): TreeNode{
            return new ColorTreeNode(row,col,id,parent,content,alphabet,depth);
        }
  
}
